import { EmergencyNotificationAcknowledgment } from '@dreryk/egabinet-emergency-notification-frontend-api';

import { StyledFlex, Text } from '@dreryk/react-components';

import { AcknowledgedByCellItem } from './AcknowledgedByCellItem';
import { AcknowledgedByCellMoreTooltip } from './AcknowledgedByCellMoreTooltip';

const VISIBLE_ACKNOWLEDGMENTS_COUNT = 2;
const EMPTY_VALUE_PLACEHOLDER = '-';

type AcknowledgedByCellProps = {
   acknowledgments: EmergencyNotificationAcknowledgment[] | undefined;
};

export const AcknowledgedByCell = (props: AcknowledgedByCellProps): JSX.Element => {
   if (!props.acknowledgments?.length) {
      return <Text testId={'acknowledgedBy'}>{EMPTY_VALUE_PLACEHOLDER}</Text>;
   }

   const visibleAcknowledgments = props.acknowledgments.slice(0, VISIBLE_ACKNOWLEDGMENTS_COUNT);
   const hiddenCount = props.acknowledgments.length - VISIBLE_ACKNOWLEDGMENTS_COUNT;

   return (
      <StyledFlex direction={'row'} alignItems={'center'} gap={'4px'}>
         <StyledFlex direction={'column'}>
            {visibleAcknowledgments.map((acknowledgment) => (
               <AcknowledgedByCellItem key={acknowledgment.id} acknowledgment={acknowledgment} />
            ))}
         </StyledFlex>
         {hiddenCount > 0 && (
            <AcknowledgedByCellMoreTooltip acknowledgments={props.acknowledgments} hiddenCount={hiddenCount} />
         )}
      </StyledFlex>
   );
};
